import Navbar from '@/components/feature/Navbar';
import SEOHead from '@/components/feature/SEOHead';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import StructuredData from '@/components/feature/StructuredData';
import HeroSection from './components/HeroSection';
import HighlightsSection from './components/HighlightsSection';
import PrizeSection from './components/PrizeSection';
import NewsSection from './components/NewsSection';
import FaqSection from './components/FaqSection';
import { siteConfig } from '@/mocks/siteData';

export default function Home() {
  return (
    <>
      <SEOHead
        title={`${siteConfig.name} - ${siteConfig.tagline}`}
        description={siteConfig.description}
        keywords="17.cn一起草每日大赛,一起草每日大赛参赛方法,17.cn每日竞技活动,一起草大赛奖励,17.cn大赛报名,每日大赛赛制规则,一起草竞技玩法"
        canonicalUrl="https://17.cn/"
      />

      <StructuredData type="Organization" />
      <StructuredData type="WebSite" />
      <StructuredData type="WebPage" data={{ name: siteConfig.name }} />
      <StructuredData type="FAQPage" />

      <Navbar />

      <main>
        <HeroSection />
        <HighlightsSection />
        <PrizeSection />

        <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto text-center">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              赛程安排
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              三级赛制，层层晋级
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto mb-10">
              从每日赛到月总决赛，每一级都充满挑战与机遇
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-100 rounded-2xl p-7 border border-background-200">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-sun-line text-xl"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">每日赛</h3>
                <p className="text-sm text-foreground-500 mb-3">每天 0:00 - 23:59</p>
                <p className="text-xs text-foreground-400">冠军 888元 · 次日12:00公布结果</p>
              </div>
              <div className="bg-background-100 rounded-2xl p-7 border border-background-200 relative">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold whitespace-nowrap">
                  人气最高
                </div>
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4 mt-2">
                  <i className="ri-calendar-event-line text-xl"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">周决赛</h3>
                <p className="text-sm text-foreground-500 mb-3">每周日 20:00</p>
                <p className="text-xs text-foreground-400">冠军 5000元 · 积分前100名参赛</p>
              </div>
              <div className="bg-background-100 rounded-2xl p-7 border border-background-200">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                  <i className="ri-trophy-line text-xl"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">月总决赛</h3>
                <p className="text-sm text-foreground-500 mb-3">每月最后一个周六 19:00</p>
                <p className="text-xs text-foreground-400">冠军 20000元 · 积分前50名参赛</p>
              </div>
            </div>
          </div>
        </section>

        <NewsSection />
        <FaqSection />

        <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              准备好展现你的实力了吗？
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mb-8">
              立即加入17.cn一起草每日大赛，与全国玩家同台竞技，赢取丰厚奖励！
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="/category/guide"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base whitespace-nowrap hover:bg-primary-600 transition-all duration-200 no-underline cursor-pointer w-full sm:w-auto text-center"
              >
                立即参赛
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="/category/rules"
                className="px-8 py-3.5 rounded-full bg-background-100 text-foreground-700 font-medium text-base whitespace-nowrap hover:bg-background-200 transition-all duration-200 no-underline cursor-pointer w-full sm:w-auto text-center border border-background-300"
              >
                了解更多
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}